// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__6SxCA","row":"styles_row__3bhR8"};